import React from 'react';
import { Card, CardProps, theme as antTheme } from 'antd';

export type IBCardProps = CardProps & {
  isCovered?: boolean;
};

const IBCard = ({ isCovered, style, children, ...rest }: IBCardProps) => {
  const { token } = antTheme.useToken();

  const styles = {
    covered: {
      borderTopWidth: '4px',
      borderTopColor: token.colorPrimary,
      borderTopStyle: 'solid',
    },
    inner: {},
  };

  return (
    // @ts-ignore - AntD CardProps onMouseEnter conflicts with Card's internal type
    <Card {...rest} style={isCovered ? { ...style, ...styles.covered } : style}>
      {children}
    </Card>
  );
};

export default IBCard;
